/** @format */

import Switch from 'react-switch';

const SwitchButton = ({
	checked,
	height = 21,
	width = 40,
	onChange,
	offHandleColor = '#fff',
	onHandleColor = '#fff',
	onColor = '#27ae60',
	offColor = '#c0392b',
	checkedIcon = false,
	uncheckedIcon = false,
	handleDiameter = 15,
	classes = 'border-secondary',
}) => {
	return (
		<Switch
			dir='rtl'
			checked={checked}
			height={height}
			width={width}
			onChange={onChange}
			offHandleColor={offHandleColor}
			onHandleColor={onHandleColor}
			offColor={offColor}
			onColor={onColor}
			checkedIcon={checkedIcon}
			uncheckedIcon={uncheckedIcon}
			handleDiameter={handleDiameter}
			className={classes}
		/>
	);
};
export default SwitchButton;
